import { createAsyncThunk } from '@reduxjs/toolkit'

import { RootState } from '../reducers'
import sessionSlice from '../reducers/sessionSlice'
import Gamer from '../services/Gamer'
import { VizType } from '../types'
import scheduleSectionEvents from './section-animation'

const setDefaultVisualization = createAsyncThunk<
  void,
  { gamer: Gamer; vizSlug: VizType },
  { state: RootState }
>('playAction/setViz', ({ gamer, vizSlug }, { dispatch, getState }) => {
  const { vizBuilder, gamerIndex: playerIndex } = gamer
  dispatch(sessionSlice.actions.setDefaultVisualizationSlug({ playerIndex, vizSlug }))
  vizBuilder.switchVisualization(vizSlug)
  dispatch(scheduleSectionEvents(gamer))
})

export default setDefaultVisualization
